import { useNavigate } from 'react-router-dom';

const CHICTemplate = ({ name, thumbnail, id }) => {
    const navigate = useNavigate();

    return (
        <div className="w-full h-[350px] flex flex-col py-[20px] bg-[#f0f0f0] items-center">
            <div className="w-[200px] 1.5xl:w-[300px] h-[200px] 1.5xl:h-[300px] bg-white bg-contain bg-no-repeat bg-center border-b-[2px] border-[#b03b8a] " style={{ backgroundImage: `url(${thumbnail})` }}>
            </div>

            <div className="mt-[24px] w-[200px] 1.5xl:w-[300px] flex flex-col">
                <h3 className="w-full text-start text-[#505050] 1.5xl:text-[18px] font-proximanova font-[700]">{name}</h3>
                <button className="mt-[8px] text-start 1.5xl:text-[18px] font-proximanova font-[700] text-charmOrange underline" onClick={() => navigate(`/explore/${id}`)}>
                    Learn more
                </button>

            </div>
        </div>
    );
}

export default CHICTemplate;